import { useTranslation } from 'modules/domains/list';
import { isNotNull } from 'utils/tsHelpers';
import { AiColor16 } from 'ui/icons';

import { FirstTier, SecondTier, Description, StyledTableCell } from './styles';
import { CellProps } from './types';
import { LIST_COLUMNS } from '../../types';
import { SEGMENTATION_URL } from '../../constants';
import { createEmailListIdParams } from '../../utils';

export const DATA_TEST = {
  brandAffinity: 'brandAffinity-icon',
};

export const NameCell = ({ row: list }: CellProps) => {
  const { t } = useTranslation();
  const segmentationListUrl = createEmailListIdParams(list, SEGMENTATION_URL);
  const id = t(`indexPage.table.columns.${LIST_COLUMNS.name}.id`, { id: list.id });

  return (
    <StyledTableCell>
      <FirstTier href={segmentationListUrl}>{list.name}</FirstTier>
      <SecondTier>
        <span>{id}</span>
        {isNotNull(list.description) && <Description>{list.description}</Description>}
        {!!list.hasBrandAffinityQuery && (
          <AiColor16 data-test={DATA_TEST.brandAffinity} width={20} height={20} />
        )}
      </SecondTier>
    </StyledTableCell>
  );
};
